import { useEffect, useRef } from 'react';
import gsap from 'gsap';

const shapes = [
  { t: 'tri', c: '#C9A84C', s: 48, x: '7%', y: '10%', r: 18 },
  { t: 'tri', c: '#ddd', s: 34, x: '90%', y: '16%', r: -12 },
  { t: 'tri', c: '#999', s: 42, x: '80%', y: '74%', r: 40 },
  { t: 'dia', c: '#C9A84C', s: 26, x: '16%', y: '76%', r: 0 },
  { t: 'tri', c: '#fff', s: 28, x: '50%', y: '6%', r: 55 },
  { t: 'cir', c: '#C9A84C', s: 14, x: '93%', y: '45%', r: 0 },
  { t: 'tri', c: '#ddd', s: 44, x: '3%', y: '50%', r: 22 },
  { t: 'dia', c: '#999', s: 20, x: '65%', y: '90%', r: 45 },
];

export default function FloatingElements() {
  const ref = useRef();
  useEffect(() => {
    const els = ref.current?.querySelectorAll('.fe');
    if (!els) return;
    const tw = [];
    els.forEach((el, i) => {
      tw.push(gsap.to(el, {
        y: `+=${18 + Math.random() * 22}`, rotation: `+=${12 + Math.random() * 20}`,
        duration: 3.5 + Math.random() * 3, ease: 'sine.inOut', repeat: -1, yoyo: true, delay: i * 0.15,
      }));
    });
    return () => tw.forEach(t => t.kill());
  }, []);

  return (
    <div ref={ref} style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 1, overflow: 'hidden' }}>
      {shapes.map((s, i) => (
        <div key={i} className="fe" style={{ position: 'absolute', left: s.x, top: s.y, transform: `rotate(${s.r}deg)`, opacity: 0.25 }}>
          <svg width={s.s} height={s.s} viewBox="0 0 100 100">
            {s.t === 'tri' && <polygon points="50,8 92,88 8,88" fill={s.c} opacity="0.5" />}
            {s.t === 'dia' && <polygon points="50,5 95,50 50,95 5,50" fill={s.c} opacity="0.4" />}
            {s.t === 'cir' && <circle cx="50" cy="50" r="40" fill="none" stroke={s.c} strokeWidth="2" opacity="0.5" />}
          </svg>
        </div>
      ))}
    </div>
  );
}
